import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        VDialog,
        {
          attrs: { width: _vm.width, persistent: true, scrollable: "" },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            VCard,
            { staticStyle: { "max-height": "700px" } },
            [
              _c(
                VCardTitle,
                {
                  staticClass: "grey lighten-3 primary--text",
                  attrs: { "primary-title": "" },
                },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "close",
                      staticStyle: { position: "absolute", right: "15px" },
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onReject()
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("icon-decline")])],
                    1
                  ),
                  _vm.custom_title
                    ? _vm._t("title")
                    : [
                        _c("div", { attrs: { color: "primary" } }, [
                          _vm._v(_vm._s(_vm.title)),
                        ]),
                      ],
                ],
                2
              ),
              _vm.isOpen
                ? _c(
                    VCardText,
                    { staticClass: "pb-0 pt-2 pl-3 pr-3  primary--text" },
                    [_vm._t("body")],
                    2
                  )
                : _vm._e(),
              _c(VDivider),
              _vm.showButtons
                ? _c(
                    VCardActions,
                    { staticClass: "pt-1 pl-3 pr-3 pb-3" },
                    [
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: { outlined: "" },
                          on: {
                            click: function ($event) {
                              return _vm.onReject()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btns.reject")))]
                      ),
                      _c(
                        VBtn,
                        {
                          staticClass: "primary",
                          attrs: { outlined: "", color: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.onAccept()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btns.accept")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }